import { createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@assets/img/Icons/success-checkmark-icon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-5bd0d727"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: { 'line-height': '24px' }
}
const _hoisted_2 = {
  key: 1,
  class: "your_card_activate_box"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "success_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_4 = { class: "payment_field" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, " Account Name ", -1))
const _hoisted_6 = { class: "information" }
const _hoisted_7 = { class: "payment_field" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = { class: "information" }
const _hoisted_10 = { class: "payment_field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "IBAN", -1))
const _hoisted_12 = { class: "information" }
const _hoisted_13 = { class: "payment_field" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "name" }, "SWIFT", -1))
const _hoisted_15 = { class: "information" }
const _hoisted_16 = { class: "payment_field" }
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "information" }
const _hoisted_19 = {
  key: 0,
  class: "payment_field"
}
const _hoisted_20 = { class: "error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal_fullscreen = _resolveComponent("modal-fullscreen")!

  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_component_modal_fullscreen, {
      visible: _ctx.visible,
      onClose: _ctx.close,
      hideFooter: false
    }, _createSlots({
      header: _withCtx(() => [
        _createTextVNode(" Top up ")
      ]),
      body: _withCtx(() => [
        (!_ctx.IsSuccess)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, " To top up your account, send funds according to the details provided below. Be sure to specify your Reference Number "))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("p", null, _toDisplayString(_ctx.$localization.getTranslate(
                "TheBalanceOnCardBeenSuccessfullyReplenished"
              )) + "! ", 1)
            ]))
      ]),
      _: 2
    }, [
      (!_ctx.IsSuccess)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.topUpByTransfer.value.AccountName), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$localization.getTranslate("Address")), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.topUpByTransfer.value.Address), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, [
                  (!_ctx.Profile || _ctx.Profile.PaymentsType == 0)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(_ctx.topUpByTransfer.value.Iban), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(_ctx.topUpByTransfer.value.Iban), 1)
                      ], 64))
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.topUpByTransfer.value.Swift), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$localization.getTranslate("PurposePayment")), 1),
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.replacedString), 1)
              ]),
              (_ctx.ErrorMessage)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.ErrorMessage), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["visible", "onClose"])
  ]))
}